import get from 'lodash/get'

const navigation = (state) => get(state, 'lookbuilder.navigation')

export const currentStep = (state) => get(navigation(state), 'currentStep')
export const isNavigatingForward = (state) => get(navigation(state), 'isNavigatingForward')
export const previousStep = (state) => get(navigation(state), 'previousStep')
